module.exports = __webpack_public_path__ + "assets/img/guangzhou.23201453.png";